export const integrationWebhooksTags = ['IntegrationWebhooks'] as const;
